<template>
	<div class="form-group mb-3" v-if="data">
        <select name="doc_type" v-model="doc_type" class="form-control" @change="selectedDocument()" :disabled="status==0 || status==1">
            <option :value="null">{{ $t('-- Select Type --') }}</option>
            <option :value="item.id" v-for="(item,index) in data" :key="item.id">{{$t(item.name)}}</option>
        </select>

        <div v-if="error" class="invalid-feedback d-block mb-3">
            {{error}}
        </div>
    </div>
</template>
<script>

  export default {
    name: 'new-doc-option',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        doc_type:null,
        error:''
      }
    },
    props: ['data','status'],
    methods:{
        selectedDocument(){
            this.$emit('selected-document',this.doc_type);
        }
    },
    mounted(){
      this.$nextTick(() => {
        if(this.data){
          this.doc_type = this.data[0].id;
          this.$emit('selected-document',this.doc_type);
        }
      });
    }
  };
</script>
